// Static verified content — sourced from https://ryanwork.online/ (scraped 4 Oct 2026)
// and cross-checked against the backend seed in /var/www/ryanads-new/backend/server.py.
// Integrity rule: NO invented numbers, roles, periods or achievements.
// Ryan's formal work periods are NOT published on ryanwork.online, so experience
// entries carry no dates (rendered without period chips on purpose).

export const STATIC_CONTENT = {
  settings: {
    name: "Ryan Hidayat",
    role_title: {
      en: "Digital Marketing & Performance Growth",
      id: "Digital Marketing & Performance Growth",
    },
    headline: {
      en: "Turning Digital Marketing Into Measurable Business Growth.",
      id: "Mengubah Pemasaran Digital Menjadi Pertumbuhan Bisnis yang Terukur.",
    },
    subheadline: {
      en: "Data-driven digital marketer with 4 years of experience across marketplace management, digital advertising (Meta, Google, Shopee & TikTok Ads), SEO & SEM — focused on efficiency, conversion and revenue growth.",
      id: "Pemasar digital berbasis data dengan 4 tahun pengalaman di marketplace management, iklan digital (Meta, Google, Shopee & TikTok Ads), SEO & SEM — fokus pada efisiensi, konversi, dan pertumbuhan revenue.",
    },
    availability: { en: "Open to Opportunities", id: "Terbuka untuk Peluang" },
    summary: {
      en: "I'm a digital marketing professional with 4 years of experience managing end-to-end digital marketing and online business development — from marketplace management and paid advertising (Marketplace Ads, Google Ads, Meta Ads) to SEO & SEM, website development and branding.\n\nMy approach is rooted in data: reading dashboards, pulling insights and turning them into decisions that cut ad costs, lift conversion rates and grow revenue. I coordinate campaigns across channels, plan budgets and optimize every Rupiah of ad spend for measurable business impact.",
      id: "Saya seorang profesional pemasaran digital dengan 4 tahun pengalaman mengelola digital marketing dan pengembangan bisnis online secara end-to-end — dari marketplace management, iklan berbayar (Marketplace Ads, Google Ads, Meta Ads), SEO & SEM, hingga pengembangan website dan branding.\n\nPendekatan saya berbasis data: membaca dashboard, menarik insight, dan mengubahnya menjadi keputusan yang menekan biaya iklan, meningkatkan konversi, dan menumbuhkan revenue. Saya mengoordinasikan kampanye lintas channel, menyusun budget, dan mengoptimalkan setiap rupiah iklan untuk dampak bisnis yang terukur.",
    },
    quote: {
      en: "Digital marketing is about connecting with the right audience, at the right time, with the right message.",
      id: "Pemasaran digital adalah tentang terhubung dengan audiens yang tepat, di waktu yang tepat, dengan pesan yang tepat.",
    },
    photo_url: "/images/ryan-portrait.png",
    whatsapp_number: "085814705924",
    whatsapp_link: "https://wa.me/6285814705924",
    email: "hi@upryan.me",
    instagram: "ryanhi18",
  },

  kpis: [
    { id: "kpi-roas-ventop", order: 0, value: 5, prefix: "", suffix: "x", decimals: 0,
      label: { en: "Marketplace ROAS", id: "ROAS Marketplace" },
      description: { en: "Ventop Sneakers — scaled from 2x ROAS while cutting ad spend from Rp 100M to Rp 60M.", id: "Ventop Sneakers — naik dari ROAS 2 dengan menekan biaya iklan dari Rp 100 jt ke Rp 60 jt." } },
    { id: "kpi-roas-cpas", order: 1, value: 7.51, prefix: "", suffix: "", decimals: 2,
      label: { en: "CPAS ROAS Peak", id: "Puncak ROAS CPAS" },
      description: { en: "Facebook Catalog Ads campaign structure, fully rebuilt and optimized.", id: "Struktur kampanye Facebook Catalog Ads (CPAS) yang dibangun ulang dan dioptimasi." } },
    { id: "kpi-roi-tiktok", order: 2, value: 9.73, prefix: "", suffix: "", decimals: 2,
      label: { en: "TikTok Ads ROI", id: "ROI TikTok Ads" },
      description: { en: "Footwear campaigns — 798 orders, CPA Rp 8.279, Rp 64.2M revenue.", id: "Kampanye footwear — 798 pesanan, CPA Rp 8.279, revenue Rp 64,2 jt." } },
    { id: "kpi-sales-drs", order: 3, value: 141, prefix: "Rp ", suffix: " jt", decimals: 0,
      label: { en: "Sales Built From Zero", id: "Penjualan Dibangun dari Nol" },
      description: { en: "DRS Racing Muffler — new store scaled to Rp 141M in 2 months with only Rp 9M ad spend.", id: "DRS Racing Muffler — toko baru mencapai Rp 141 jt dalam 2 bulan dengan iklan Rp 9 jt." } },
  ],

  case_studies: [
    {
      id: "case-ventop", order: 0, brand: "Ventop Sneakers (Mall Ori)",
      industry: { en: "E-Commerce · Fashion Footwear", id: "E-Commerce · Footwear Fashion" },
      channels: ["Shopee Ads", "TikTok Ads", "Facebook CPAS"],
      title: { en: "Cutting ad costs in half while doubling ROAS", id: "Memotong biaya iklan separuh sambil menggandakan ROAS" },
      challenge: {
        en: "Campaigns were burning budget: ROAS stuck at 2x with Rp 100M ad spend generating Rp 314M revenue. The goal was to cut ad costs without sacrificing revenue.",
        id: "Kampanye membakar budget: ROAS stagnasi di angka 2 dengan biaya iklan Rp 100 jt untuk pendapatan Rp 314 jt. Tujuannya: menekan biaya iklan tanpa mengorbankan pendapatan.",
      },
      strategy: {
        en: "Full-funnel restructure — audit the campaign structure, prioritize winning SKUs, rebuild retargeting audiences, and reallocate budget from inefficient ads to proven converters across Shopee Ads, TikTok Ads and Facebook CPAS.",
        id: "Restrukturisasi full-funnel — audit struktur kampanye, prioritaskan SKU yang menang, bangun ulang audiens retargeting, dan alihkan budget dari iklan yang tidak efisien ke yang terbukti konversi di Shopee Ads, TikTok Ads, dan Facebook CPAS.",
      },
      execution: {
        en: "Daily and weekly optimization: bid and budget adjustments, keyword blacklisting, pausing ineffective ads, scaling profitable campaigns, and tightening the CPAS campaign structure.",
        id: "Optimasi harian dan mingguan: penyesuaian bidding dan budget, blacklist keyword, mematikan iklan yang tidak efektif, scaling kampanye yang perform, dan menyempurnakan struktur kampanye CPAS.",
      },
      result: {
        en: "ROAS doubled to 5x with only Rp 60M spend (~Rp 300M revenue). Ad costs dropped nearly 50%. CPAS campaigns peaked at 7.51 ROAS, and TikTok delivered 9.73 ROI with 798 orders at Rp 8.279 CPA.",
        id: "ROAS naik menjadi 5 dengan biaya iklan hanya Rp 60 jt (pendapatan ±Rp 300 jt). Biaya iklan turun hampir 50%. Kampanye CPAS mencapai ROAS 7,51, dan TikTok memberi ROI 9,73 dengan 798 pesanan pada CPA Rp 8.279.",
      },
      metrics: [
        { value: "5x", label: { en: "ROAS after optimization", id: "ROAS setelah optimasi" } },
        { value: "-48%", label: { en: "Ad cost reduction", id: "Penurunan biaya iklan" } },
        { value: "7.51", label: { en: "CPAS ROAS peak", id: "Puncak ROAS CPAS" } },
        { value: "9.73", label: { en: "TikTok Ads ROI", id: "ROI TikTok Ads" } },
      ],
      image_url: "/images/case-ventop-tiktok.jpg",
      chart_data: [
        { label: { en: "Before", id: "Sebelum" }, value: 2 },
        { label: { en: "After", id: "Sesudah" }, value: 5 },
      ],
    },
    {
      id: "case-drs", order: 1, brand: "DRS Racing Muffler",
      industry: { en: "Automotive · Motorcycle Parts", id: "Otomotif · Suku Cadang Motor" },
      channels: ["Shopee Ads"],
      title: { en: "From zero sales to Rp 141M in two months", id: "Dari nol penjualan menjadi Rp 141 jt dalam dua bulan" },
      challenge: {
        en: "A brand-new store starting from absolute zero — no sales history, no reviews, no ranking and no visibility on Shopee.",
        id: "Toko baru mulai dari nol absolut — belum ada riwayat penjualan, review, ranking, maupun visibility di Shopee.",
      },
      strategy: {
        en: "Aggressive but controlled CPC campaigns: keyword and audience research, prioritized SKUs, and a conversion-focused campaign structure built from day one.",
        id: "Kampanye CPC yang agresif namun terkendali: riset keyword dan audiens, prioritas SKU, serta struktur kampanye yang berfokus pada konversi sejak hari pertama.",
      },
      execution: {
        en: "Hands-on daily optimization of bids, budgets and search terms — scaling every ad that performed and cutting everything that did not.",
        id: "Optimasi harian langsung pada bidding, budget, dan search term — scaling setiap iklan yang perform dan mematikan yang tidak.",
      },
      result: {
        en: "From 0 to Rp 141M in sales within 2 months, with only Rp 9M in ad spend — a 15.70 ROAS visible on the store dashboard.",
        id: "Dari 0 menjadi Rp 141 jt penjualan dalam 2 bulan, hanya dengan biaya iklan Rp 9 jt — ROAS 15,70 terlihat jelas di dashboard toko.",
      },
      metrics: [
        { value: "Rp 141 jt", label: { en: "Sales in 2 months", id: "Penjualan dalam 2 bulan" } },
        { value: "Rp 9 jt", label: { en: "Total ad spend", id: "Total biaya iklan" } },
        { value: "15.70", label: { en: "ROAS", id: "ROAS" } },
      ],
      image_url: "/images/case-drs-dashboard.png",
      chart_data: [
        { label: { en: "Month 1", id: "Bulan 1" }, value: 0 },
        { label: { en: "Month 2", id: "Bulan 2" }, value: 141 },
      ],
    },
    {
      id: "case-kenzo", order: 2, brand: "Kenzo Boiler",
      industry: { en: "Industrial · Boiler Manufacturing", id: "Industri · Manufaktur Boiler" },
      channels: ["Social Media", "Marketplace Ads", "Website Development"],
      title: { en: "Building a digital presence for an industrial brand", id: "Membangun kehadiran digital untuk brand industri" },
      challenge: {
        en: "An industrial boiler manufacturer with little digital footprint needed to reach B2B buyers and open a sales channel online.",
        id: "Produsen boiler industri dengan jejak digital minim perlu menjangkau pembeli B2B dan membuka channel penjualan online.",
      },
      strategy: {
        en: "Integrated digital foundation — company website, professional social media management, and marketplace optimization supported by paid ads.",
        id: "Fondasi digital terintegrasi — website perusahaan, pengelolaan media sosial profesional, dan optimasi marketplace yang didukung iklan berbayar.",
      },
      execution: {
        en: "Website development (kenzoboiler.com), ongoing social media content, marketplace listing optimization and ad campaign management.",
        id: "Pengembangan website (kenzoboiler.com), konten media sosial berkelanjutan, optimasi listing marketplace, dan pengelolaan kampanye iklan.",
      },
      result: {
        en: "A complete digital presence: an indexed company website, actively managed social channels and a marketplace sales channel supported by ads.",
        id: "Kehadiran digital yang lengkap: website perusahaan yang ter-index, media sosial yang aktif dikelola, dan channel penjualan marketplace yang didukung iklan.",
      },
      metrics: [],
      image_url: "/images/case-kenzo.jpg",
    },
    {
      id: "case-magnofy", order: 3, brand: "Magnofy Apparel",
      industry: { en: "Fashion · Apparel", id: "Fashion · Pakaian" },
      channels: ["TikTok Ads", "SEO", "Website", "Social Media"],
      title: { en: "End-to-end launch of a fashion label", id: "Peluncuran menyeluruh label fashion" },
      challenge: {
        en: "A new apparel brand launching from scratch: no brand identity, no online store and no first customers.",
        id: "Brand apparel baru yang lahir dari nol: belum ada identitas merek, toko online, maupun pelanggan pertama.",
      },
      strategy: {
        en: "Own the full stack of the launch: branding and logo design, a website with payment integration, SEO foundations, social media management and TikTok ads to drive the first sales.",
        id: "Mengerjakan seluruh stack peluncuran: branding dan desain logo, website dengan integrasi pembayaran, fondasi SEO, pengelolaan media sosial, dan iklan TikTok untuk mendorong penjualan pertama.",
      },
      execution: {
        en: "Logo and identity creation, e-commerce website build with payment gateway, SEO indexing, content production and managed TikTok ad campaigns.",
        id: "Pembuatan logo dan identitas, pembangunan website e-commerce dengan payment gateway, indexing SEO, produksi konten, dan pengelolaan kampanye iklan TikTok.",
      },
      result: {
        en: "A complete brand launch delivered: identity, e-commerce website with payments, SEO indexing and running TikTok acquisition campaigns.",
        id: "Peluncuran brand yang lengkap: identitas, website e-commerce dengan pembayaran, indexing SEO, dan kampanye akuisisi TikTok yang berjalan.",
      },
      metrics: [],
      image_url: "/images/case-magnofy.jpg",
    },
  ],

  experiences: [
    {
      id: "exp-freelance", order: 0,
      role: { en: "Marketplace Ads Specialist", id: "Marketplace Ads Specialist" },
      company: "Freelance",
      period: null, // not published on ryanwork.online — intentionally left undated
      responsibilities: {
        en: "Ad research & strategy (audience, keywords, priority products) · Campaign setup across Shopee, Tokopedia, TikTok Shop & Lazada Ads · Daily/weekly optimization: lowering CPC & CPA, raising ROAS, bidding, budget allocation · Data analysis & reporting: impressions, clicks, sales, ROAS · Improvement recommendations: titles, SKU priority, pricing & promos, scaling decisions.",
        id: "Riset & strategi iklan (audiens, keyword, produk prioritas) · Setting campaign di Shopee, Tokopedia, TikTok Shop & Lazada Ads · Optimasi harian/mingguan: menurunkan CPC & CPA, meningkatkan ROAS, bidding, alokasi budget · Analisa data & reporting: impression, klik, penjualan, ROAS · Rekomendasi perbaikan: judul, prioritas SKU, harga & promo, keputusan scaling.",
      },
      achievements: { en: "", id: "" },
    },
  ],

  skills: [
    { id: "skill-performance", order: 0,
      title: { en: "Performance Marketing", id: "Performance Marketing" },
      description: { en: "Paid campaigns engineered for conversion, not vanity metrics.", id: "Kampanye berbayar yang dirancang untuk konversi, bukan sekadar metrik popularitas." },
      items: ["Meta Ads", "Google Ads", "Campaign Optimization", "Conversion Rate Optimization", "Retargeting"] },
    { id: "skill-seo", order: 1,
      title: { en: "SEO", id: "SEO" },
      description: { en: "Search visibility built on technical foundations and content strategy.", id: "Visibilitas pencarian yang dibangun di atas fondasi teknis dan strategi konten." },
      items: ["Technical SEO", "On-Page SEO", "Keyword Research", "SEO Content Strategy", "Google Search Console"] },
    { id: "skill-marketplace", order: 2,
      title: { en: "Marketplace Growth", id: "Marketplace Growth" },
      description: { en: "Winning the buy-box battle on Shopee, Tokopedia and beyond.", id: "Memenangkan pertarungan visibility di Shopee, Tokopedia, dan lainnya." },
      items: ["Shopee Ads", "Marketplace Optimization", "Product Performance Analysis", "Marketplace Campaign Strategy"] },
    { id: "skill-analytics", order: 3,
      title: { en: "Analytics & Reporting", id: "Analytics & Reporting" },
      description: { en: "Every decision backed by a number on a dashboard.", id: "Setiap keputusan didukung angka di dashboard." },
      items: ["KPI Tracking", "ROAS, CPA, CTR, CPC, CPM", "Campaign Reporting", "Performance Analysis"] },
    { id: "skill-leadership", order: 4,
      title: { en: "Leadership & Strategy", id: "Kepemimpinan & Strategi" },
      description: { en: "Coordinating people and channels around one growth plan.", id: "Mengoordinasikan tim dan channel dalam satu rencana pertumbuhan." },
      items: ["Digital Marketing Strategy", "Team Coordination", "Budget Planning", "Cross-Channel Marketing"] },
    { id: "skill-ai", order: 5,
      title: { en: "AI & Marketing Automation", id: "AI & Automation Pemasaran" },
      description: { en: "Support layer: AI-assisted workflows that multiply output.", id: "Lapisan pendukung: workflow berbantuan AI yang melipatgandakan output." },
      items: ["AI-Assisted Marketing Workflow", "Marketing Automation", "AI Content Workflow", "Workflow Integration"] },
  ],

  certifications: [
    { id: "cert-google-ads", order: 0, name: { en: "Google Ads Certification", id: "Sertifikasi Google Ads" }, issuer: "Google", year: "", credential_url: "" },
    { id: "cert-google-video", order: 1, name: { en: "Google Ads Video Certification", id: "Sertifikasi Google Ads Video" }, issuer: "Google", year: "", credential_url: "" },
    { id: "cert-seo-skillpedia", order: 2, name: { en: "Search Engine Optimization", id: "Search Engine Optimization" }, issuer: "skillpedia.id", year: "", credential_url: "" },
    { id: "cert-seo-fundamental", order: 3, name: { en: "SEO Fundamental", id: "SEO Fundamental" }, issuer: "myskill.id", year: "", credential_url: "" },
    { id: "cert-google-setup", order: 4, name: { en: "Google Ads Setup", id: "Google Ads Setup" }, issuer: "myskill.id", year: "", credential_url: "" },
  ],
};
